import React from 'react';
import { Link } from 'react-router-dom';

/* Single oval app tile in the GCU-style apps grid, with ZHELTA gold theming. */
export default function AppTile({ to, icon: Icon, label, testId }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className="group flex flex-col items-center text-center px-4 py-6 rounded-2xl bg-white border border-[#E5E5E7] hover:border-[#c9a227] hover:shadow-[0_15px_30px_-15px_rgba(201,162,39,0.4)] transition-all"
    >
      <div
        className="w-[78px] h-[88px] flex items-center justify-center mb-3 transition-transform group-hover:scale-105"
        style={{
          borderRadius: '50%',
          background: 'linear-gradient(135deg,#c9a227 0%,#a8871a 100%)',
          boxShadow: '0 8px 18px -8px rgba(201,162,39,0.55)',
        }}
      >
        <Icon className="w-9 h-9 text-white" strokeWidth={1.7} />
      </div>
      <span className="text-[13px] font-semibold text-[#1D1D1F] group-hover:text-[#c9a227] transition-colors leading-tight">
        {label}
      </span>
    </Link>
  );
}
